/**
 * # Events Mixin
 * Add events to Spark Components
 *
 * @example
 * mixin(Component, events);
 *
 * @module mixin/events.js
 * @since 3.2.1
 */

export default {

  /**
   * on
   * @param {String} event
   * @param {Function} callback
   * @param {Object} data
   */
  on(event, callback, data = {}) {
    if (!Array.isArray(this._events)) {
      this._events = [];
    }

    if (!this._events.some(subscription => subscription.name === event.toLowerCase() && subscription.method === callback)) {
      this._events.push({
        name: event.toLowerCase(),
        method: callback,
        data: data
      });
    }
  },


  /**
   * off
   * @param {String} event
   * @param {Function} callback
   */
  off(event, callback) {
    if (!Array.isArray(this._events)) {
      this._events = [];
    } else {
      this._events = this._events.filter(subscription => subscription.name !== event.toLowerCase() && subscription.method !== callback);
    }
  },


  /**
   * trigger
   * @param {String} event
   * @param {*} params
   * @return {Promise}
   */
  trigger(event, ...params) {
    if (!Array.isArray(this._events)) {
      this._events = [];
    }

    const registeredCallbacks = this._events.filter(subscription => subscription.name === event);

    const callbackEvent = document.createEvent('Event');
    callbackEvent.initEvent(event.toLowerCase(), true, true);
    callbackEvent.component = this;
    if (params && typeof params[0] === 'object' && typeof params[0].event === 'object') Object.assign(callbackEvent, params[0].event);
    if (this.el) this.el.dispatchEvent(callbackEvent);

    registeredCallbacks.forEach(subscription => {
      callbackEvent.data = subscription.data;
      subscription['method'](callbackEvent, ...params);
    });
  }
};
